import { Application } from './components/application';
import { ApplicationContext } from './components/context/application.context';
import { Logger } from './components/logger/logger';
import { API_URL, APP_VERSION } from './constants';
import { Kernel } from './kernel';
import { Navigation } from './polyfill/navigation';
import { ApplicationConfig, ExternalConfig } from './types';
import { mergeObjects } from './utils/object';
import { applicationConfigSchema, externalConfigSchema } from './utils/schema';

export const runApplication = (w: Window): void => {
  if (!w.RevopsObject) {
    return;
  }

  if (!w[ 'navigation' ]) {
    w.navigation = new Navigation();
  }

  let externalConfig: ExternalConfig = {} as ExternalConfig;

  for (const item of w[ w.RevopsObject ].q) {
    const [ key, value ] = item;

    if (key === 'config' && typeof value === 'object') {
      externalConfig = mergeObjects(externalConfig, value);
    }
  }

  externalConfig = externalConfig?.debug
    ? externalConfigSchema.strict().parse(externalConfig)
    : externalConfigSchema.parse(externalConfig)
  ;

  Object.freeze(externalConfig); // Prevent changing the external config after is initialized

  const scriptTag = w.document.querySelector<HTMLScriptElement>(
    `script[id="${externalConfig.scriptId}"]`,
  );

  if (!scriptTag) {
    throw new Error('Script Tag not found');
  }

  let applicationConfig = mergeObjects<ApplicationConfig>(externalConfig, {
    widgetInstallUrl: scriptTag.src,
    version: APP_VERSION || '1.0.0',
    apiUrl: API_URL,
  });

  applicationConfig = applicationConfig?.debug
    ? applicationConfigSchema.strict().parse(applicationConfig)
    : applicationConfigSchema.parse(applicationConfig)
  ;

  Object.freeze(applicationConfig); // Prevent changing the config after is initialized

  const applicationContext = new ApplicationContext(applicationConfig, w);
  const kernel = new Kernel(applicationContext);
  kernel.boot();

  const logger = kernel.getContainer().get<Logger | undefined>(Logger);
  const application = kernel.getContainer().get<Application>(Application);

  document.addEventListener('visibilitychange', (): void => {
    if (document.visibilityState === 'hidden') {
      logger?.info('cleanup queue');
    }
  });

  // w.navigation.addEventListener('navigatesuccess', (): void => {
  //   logger?.info('Rendering application on navigatesuccess');
  //   application.run();
  // });

  if (w.document.readyState !== 'complete') {
    w.addEventListener('load', (): void => {
      logger?.info('Run application on window load');
      application.run();
    });
  } else {
    logger?.info('Run application on complete');
    application.run();
  }
};
